/* ==================================================================================================
HANDLES THE AJAX CART & MEAL PLANS BUILDER SYNC
==================================================================================================*/

// packages
import axios from "axios";

// helpers
import {
  waitForElm,
  showCorrectPrice,
  randomString,
  getCookie,
  generateBoxID,
  calculateMealCount,
  getDayOfWeek,
} from "./helpers/index.js";

import {
  hydrateCalculator,
  hydrateAddons,
  hydrateBar,
} from "./helpers/hydration.js";

// custom components
import "./components/checkoutButton.js";
import "./components/preCheckout.js";
import "./components/mealPlanAddons.js";
import {doc} from "prettier";

// on mount, create our cookie
if (getCookie("bid") == undefined || getCookie("bid") == null) {
  document.cookie = `bid=${randomString()}`;
}

/*

==================================================================================================

CUSTOM ELEMENTS

==================================================================================================

*/

/**
 * A special Product Card button that adds a single meal to a meal plan
 *
 * @class MealPlanAdd
 * @typedef {MealPlanAdd}
 * @extends {HTMLElement}
 */
if (!customElements.get("meal-plan-add")) {
  class MealPlanAdd extends HTMLElement {
    constructor() {
      super();

      this.addEventListener("click", (e) => {
        e.preventDefault();
        let _kind = this.getAttribute("kind");
        let _id = this.dataset.id;
        let _plan = this.getAttribute("data-selling-plan");
        let _type = this.getAttribute("type");
        let _cartType = localStorage.getItem("cartType");
        const _redirect = this.dataset.redirect;
        this.addToCart(_id, _kind, _type, _plan, _redirect, _cartType);
      });
    }

    /**
     * Add product to cart when quanitiy is 0
     *
     * @async
     * @param {String} id
     * @param {String} kind
     * @param {String} type
     * @returns {*}
     */
    async addToCart(id, kind, type, plan, redirect, _type) {
      let _dd =
        getDayOfWeek(localStorage.getItem("lastSelectedDeliveryDate")) ||
        getDayOfWeek(localStorage.getItem("firstDeliveryDate")) ||
        document.querySelector('[js-selected-day="target"]')?.dataset.day;

      let scheduleDelivery =
        localStorage.getItem("lastSelectedDeliveryDate")?.replace(/-/g, "/") ||
        localStorage.getItem("firstDeliveryDate")?.replace(/-/g, "/");

      const latestSellingPlans = await fetch(
        `https://eatunique.ch/collections/create-meal-plan?view=subscriptions-raw`,
      );
      const sellingPlanData = await latestSellingPlans.json();

      const findSellingPlanByProductVariantID = (id) => {
        const product = sellingPlanData.find((item) => item.variant_id === id);
        return product ? product.subscription_id : null;
      };

      let formData = {
        items: [
          {
            id: id,
            quantity: 1,
            selling_plan: plan || findSellingPlanByProductVariantID(id),
            properties: {
              _subscription_id: plan || findSellingPlanByProductVariantID(id),
              _box_id: generateBoxID(),
              _delivery_date: _dd,
              Abo: "Du erhältst jede Woche deinen Rabatt",
              "Delivery Day": _dd,
              "Schedule Delivery": scheduleDelivery,
              _type: "Subscription",
              _frontend: true,
            },
          },
        ],
      };

      let formDataNoSub = {
        items: [
          {
            id: id,
            quantity: 1,
            selling_plan: null,
            properties: {
              _subscription_id: plan || findSellingPlanByProductVariantID(id),
              _box_id: generateBoxID(),
              _delivery_date: _dd,
              _type: "One Time Purchase",
              _frontend: true,
            },
          },
        ],
      };

      /**
       * repalce the first initial 'add to plan' button with the quantity selector
       *
       * @param {Array} d
       * @param {String} id
       * @param {String} t
       */
      const prepareAdjustableQuantity = (d, id, t) => {
        id = parseInt(id);
        d.map((product) => {
          if (product.variant_id === id) {
            if (t == "meal-plan-add") {
              if (document.querySelector(`#mpa-${id}`)) {
                document
                  .querySelector(`#mpa-${id}`)
                  .setAttribute("data-quantity", product.quantity);
                document.querySelector(
                  `#mpa-${id} #adjusted-cart-amount`,
                ).innerHTML = product.quantity;

                this.classList.add("visually-hidden");
                document
                  .querySelector(`#mpa-${id}`)
                  .classList.remove("visually-hidden");
              }
            } else {
              if (document.querySelector(`#popup-mpa-${id}`)) {
                document
                  .querySelector(`#popup-mpa-${id}`)
                  .setAttribute("data-quantity", product.quantity);

                if (
                  document.querySelector(
                    `#popup-mpa-${id} #adjusted-cart-amount`,
                  )
                ) {
                  document.querySelector(
                    `#popup-mpa-${id} #adjusted-cart-amount`,
                  ).innerHTML = product.quantity;
                }

                this.classList.add("visually-hidden");
                document
                  .querySelector(`#popup-mpa-${id}`)
                  .classList.remove("visually-hidden");
              }

              if (document.querySelector(`#mpa-${id}`)) {
                document
                  .querySelector(`#mpa-${id}`)
                  .setAttribute("data-quantity", product.quantity);
                document.querySelector(
                  `#mpa-${id} #adjusted-cart-amount`,
                ).innerHTML = product.quantity;

                document
                  .querySelector(`#mpa-${id}`)
                  .classList.remove("visually-hidden");

                // remove the card <meal-plan-add>
                if (
                  document.querySelector(
                    `#meal-plan-add-${id}[type="meal-plan-add"]`,
                  )
                ) {
                  document
                    .querySelector(`#meal-plan-add-${id}[type="meal-plan-add"]`)
                    .classList.add("visually-hidden");
                }
              }
            }
          }
        });
      };

      try {
        if (
          plan == null ||
          (undefined && findSellingPlanByProductVariantID(id) == null) ||
          undefined
        ) {
          console.error(`Error adding to cart: Couldn't find subscription ID`);
        } else {
          const response = await axios.post(
            window.Shopify.routes.root + "cart/add.js",
            _type != "otp" ? formData : formDataNoSub,
          );
          const res = await response;

          if (res.status !== 200) {
            throw new Error(`Request failed with status ${res.status}`);
          }
          if (kind == "Addon") {
            document.dispatchEvent(
              new CustomEvent("addon:add_to_cart", {
                detail: res
              })
            );
            hydrateAddons(res);
          } else {
            document.dispatchEvent(
              new CustomEvent("meal:add_to_cart", {
                detail: res
              })
            );
            hydrateCalculator(res);
          }
          prepareAdjustableQuantity(res?.data?.items, this.dataset.id, type);
          if (redirect == "true" || redirect == true) {
            this.redirectToMealPlan();
          }
        }

        // TODO: @sid this should replace the need for updateButtonDiffText()
        // const items = res.data.items;
        // const mealCount = calculateMealCount(items);

        // // dispatch the customer event
        // const event = new CustomEvent("cart-update", {
        //   detail: {
        //     mealCount: mealCount,
        //     cart: res.data,
        //   },
        // });
      } catch (err) {
        console.log(err);
      }
    }

    redirectToMealPlan() {
      window.location.href = `${window.routes.root_url}collections/create-meal-plan`;
    }
  }

  customElements.define("meal-plan-add", MealPlanAdd);
}

/**
 * The Adjustable quantity selecotr for a meal in a meal plan
 *
 * @class MealPlanAdjust
 * @typedef {MealPlanAdjust}
 * @extends {HTMLElement}
 */
class MealPlanAdjust extends HTMLElement {
  constructor() {
    super();

    let _spinner = ` <div id="mini-cart-loader-pdp-button" class="loader-indicator">
    <span class="spinner"></span>
  </div>`;

    this.querySelector("#quantity-up").addEventListener("click", (e) => {
      e.preventDefault();

      const _redirect = this.dataset.redirect;
      let _type = this.getAttribute("type");
      let _id = this.dataset.id;
      let _q = parseInt(this.dataset.quantity) + 1;

      if (_type == "meal-plan-adjust-cart") {
        this.updateCart(_id, _q, _redirect);
      } else {
        this.insertAdjacentHTML("afterbegin", _spinner);
        this.updateCart(_id, _q, _redirect).then((data) => {
          if (data.status == 200) {
            this.querySelector("#mini-cart-loader-pdp-button")?.remove();
          }
        });
      }
    });

    this.querySelector("#quantity-down").addEventListener("click", (e) => {
      e.preventDefault();

      const _redirect = this.dataset.redirect;
      let _type = this.getAttribute("type");
      let _id = this.dataset.id;

      if (parseInt(this.dataset.quantity) == 1) {
        let _q = parseInt(this.dataset.quantity) - 1;

        if (_type == "meal-plan-adjust-cart") {
          this.updateCart(_id, _q, _redirect);

          this.classList.add("visually-hidden");
          document
            .querySelector(`[js-product-card="container"] #mpa-${_id}`)
            .classList.add("visually-hidden");
          document
            .querySelector(`#meal-plan-add-${_id}`)
            .classList.remove("visually-hidden");
        } else {
          this.insertAdjacentHTML("afterbegin", _spinner);
          this.updateCart(_id, _q, _redirect).then((data) => {
            if (data.status == 200) {
              this.querySelector("#mini-cart-loader-pdp-button").remove();
              this.classList.add("visually-hidden");
              document
                .querySelector(`[js-product-card="container"] #mpa-${_id}`)
                .classList.add("visually-hidden");
              document
                .querySelector(`#meal-plan-add-${_id}`)
                .classList.remove("visually-hidden");

              if (
                document.querySelector(
                  `#meal-plan-add-${_id}[type="meal-plan-add"]`,
                )
              ) {
                document
                  .querySelector(`#meal-plan-add-${_id}[type="meal-plan-add"]`)
                  .classList.remove("visually-hidden");
              }
            }
          });
        }
      } else {
        if (_type == "meal-plan-adjust-cart") {
          let _q = parseInt(this.dataset.quantity) - 1;
          this.updateCart(_id, _q, _redirect);
        } else {
          let _q = parseInt(this.dataset.quantity) - 1;
          this.insertAdjacentHTML("afterbegin", _spinner);
          this.updateCart(_id, _q, _redirect).then((data) => {
            if (data.status == 200) {
              this.querySelector("#mini-cart-loader-pdp-button").remove();
            }
          });
        }
      }
    });
  }

  /**
   * Update product quantity in cart
   *
   * @async
   * @param {String} id
   * @param {Number} q
   * @returns {unknown}
   */
  async updateCart(id, q, redirect) {
    let formData = {
      id: id,
      quantity: q,
    };

    /**
     * Update quanitiy selector to match carts line item by id
     *
     * @param {Array} d
     * @param {String} id
     */
    const findTargetProduct = (d, id, k) => {
      id = parseInt(id);

      d.map((product) => {
        if (product.variant_id === id) {
          this.setAttribute("data-quantity", product.quantity);
          if (
            document.querySelector(`[js-product-card="container"] #mpa-${id}`)
          ) {
            document
              .querySelector(`[js-product-card="container"] #mpa-${id}`)
              .setAttribute("data-quantity", product.quantity);
          }

          if (k == "Addon") {
            this.querySelector("#adjusted-cart-amount").innerHTML =
              product.quantity;
          }

          if (
            document.querySelector(
              `[js-product-card="container"] #mpa-${id} #adjusted-cart-amount`,
            )
          ) {
            document.querySelector(
              `[js-product-card="container"] #mpa-${id} #adjusted-cart-amount`,
            ).innerHTML = product.quantity;
          }
        }
      });
    };

    try {
      const response = axios.post(
        window.Shopify.routes.root + "cart/change.js",
        formData,
      );
      const res = await response;

      if (res.status !== 200) {
        throw new Error(`Request failed with status ${res.status}`);
      }

      if (this.dataset.kind == "Addon") {
        hydrateAddons(res);
      } else {
        hydrateCalculator(res, id);
      }

      findTargetProduct(res?.data?.items, this.dataset.id, this.dataset.kind);

      const items = res.data.items;
      const mealCount = calculateMealCount(items);

      hydrateBar(mealCount);

      // dispatch the customer event
      const event = new CustomEvent("cart-update", {
        detail: {
          mealCount: mealCount,
          cart: res.data,
        },
      });
      document.dispatchEvent(event);

      if (redirect == "true" || redirect == true) {
        this.redirectToMealPlan();
      }

      return res;
    } catch (err) {
      console.log(err);
    }
  }

  redirectToMealPlan() {
    window.location.href = `${window.routes.root_url}collections/create-meal-plan`;
  }
}

customElements.define("meal-plan-adjust", MealPlanAdjust);

/*

==================================================================================================

PAYMENT OPTIONS SWITCHER

==================================================================================================

*/

/**
 * Custom wrapper that lets customer choose a subscription or one time payment
 *
 * @class PaymentOptions
 * @typedef {PaymentOptions}
 * @extends {HTMLElement}
 */
class PaymentOptions extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll(".option-selector").forEach((option) => {
      option.addEventListener("click", () => {
        const _type = option.getAttribute("data-type");
        const _date = localStorage.getItem("lastSelectedDeliveryDate");
        this.querySelectorAll(".option-selector").forEach((i) => {
          i.closest(".option").classList.remove("active");
        });
        option.closest(".option").classList.add("active");
        this.setAttribute("data-active", _type);
        localStorage.setItem("cartType", _type);
        this.determineSellingPlans(_type, _date);
      });
    });

    document.querySelectorAll(".day-button").forEach((day) => {
      day.addEventListener("click", () => {
        const _type = localStorage.getItem("cartType");
        const _date = localStorage.getItem("lastSelectedDeliveryDate");
        this.determineSellingPlans(_type, _date);
      });
    });

    window.addEventListener("TriggerUpdateCart", (e) => {
      const _type = localStorage.getItem("cartType");
      const _date = localStorage.getItem("lastSelectedDeliveryDate");
      this.determineSellingPlans(_type, _date);
    });

    // Select right meal price on page load

    document.addEventListener("DOMContentLoaded", () => {
      showCorrectPrice();
    });
  }

  // watch for changes in the selected checkout option
  static get observedAttributes() {
    return ["data-delivery-date"];
  }

  // on mount make sure subscription is default
  connectedCallback() {
    let cartType;

    // set the first delivery date as the default option on mount
    waitForElm(".days .day.available").then((elm) => {
      let fd = document.querySelector(".days .day.available");
      if (document.querySelector("#payment-options-main")) {
        document
          .querySelector("#payment-options-main")
          .setAttribute("data-delivery-date", fd.innerText);

        if (localStorage.getItem("deliveryDateLong") === null) {
          document.querySelector(".selected-date span").innerHTML =
            fd.innerText;
        } else {
          document.querySelector(".selected-date span").innerHTML =
            localStorage.getItem("deliveryDateLong");
        }
      }
    });

    if (
      localStorage.getItem("cartType") === null ||
      localStorage.getItem("cartType") == ""
    ) {
      localStorage.setItem("cartType", "sub");
      cartType = "sub";
    } else {
      cartType = localStorage.getItem("cartType");
    }
    this.setAttribute("data-active", cartType);

    this.querySelectorAll(".option").forEach((option) => {
      option.classList.remove("active");
      if (option.id.includes(localStorage.getItem("cartType"))) {
        option.classList.add("active");
      }
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    let _date = this.getAttribute("data-delivery-date");
    if (name == "data-delivery-date") {
      let d = _date.split(",");

      if (oldValue != null) {
        this.addDeliveryDate(d[0]);
        localStorage.setItem("deliveryDateLong", _date);
        this.determineSellingPlans(localStorage.getItem("cartType"));
      }
    }
  }

  // handles the stroing of users prefereed delivery date
  addDeliveryDate(d) {
    localStorage.setItem("deliveryDate", d);
  }

  /**
   * Clears the current cart and re adds the items with thier attached selling plan id if any
   *
   * @async
   * @param {String} kind - either otp or sub
   * @returns {*}
   */
  async determineSellingPlans(kind, sheduled) {
    showCorrectPrice();
    this.disableCheckoutTemp();

    let itemsToUpdate = [];
    let itemsToUpdateNoSub = [];

    const latestSellingPlans = await fetch(
      `https://eatunique.ch/collections/create-meal-plan?view=subscriptions-raw`,
    );
    const sellingPlanData = await latestSellingPlans.json();

    const findSellingPlanByProductID = (id) => {
      const product = sellingPlanData.find((item) => item.product_id === id);
      return product ? product.subscription_id : null;
    };

    // get the latest cart
    try {
      const updatedCart = await axios.get(
        window.Shopify.routes.root + "cart.js",
      );
      const res = await updatedCart;

      if (res.status !== 200) {
        throw new Error(`Request failed with status ${res.status}`);
      }

      // store cart items to this var
      let tempItems = updatedCart.data.items;
      let _dd =
        document.querySelector("day-picker")?.dataset.dayEn || "Tuesday";
      let scheduleDelivery =
        localStorage.getItem("lastSelectedDeliveryDate")?.replace(/-/g, "/") ||
        localStorage.getItem("firstDeliveryDate")?.replace(/-/g, "/");

      console.log("Switching cart");

      // map through the array and get only the data we need
      tempItems.map((i) => {
        let k = i.id;
        let q = i.quantity;
        let _data = {
          id: k,
          quantity: q,
          selling_plan:
            i.properties?._subscription_id ||
            findSellingPlanByProductID(i?.product_id),
          properties: {
            _subscription_id:
              i.properties?._subscription_id ||
              findSellingPlanByProductID(i?.product_id),
            _box_id: generateBoxID(),
            _delivery_date: _dd,
            "Schedule Delivery": scheduleDelivery,
            Abo: "Du erhältst jede Woche deinen Rabatt",
            _type: "Subscription",
            _frontend: true,
          },
        };
        let _datanoSub = {
          id: k,
          quantity: q,
          selling_plan: null,
          properties: {
            _subscription_id:
              i.properties?._subscription_id ||
              findSellingPlanByProductID(i?.product_id),
            _box_id: generateBoxID(),
            _delivery_date: _dd,
            "Schedule Delivery": scheduleDelivery,
            _type: "One Time Purchase",
            _frontend: true,
          },
        };
        // push the data to the temp arrays
        itemsToUpdate.push(_data);
        itemsToUpdateNoSub.push(_datanoSub);
      });
    } catch (err) {
      console.log(err);
    }

    // if subscription is selected. clear cart then re add items from temp array
    if (kind != "otp") {
      console.log("Subscription");

      let formData;

      if (sheduled) {
        formData = {
          attributes: {
            _sheduled: sheduled,
          },
          items: itemsToUpdate,
        };
      } else {
        formData = {
          items: itemsToUpdate,
        };
      }

      try {
        await axios.post(window.Shopify.routes.root + "cart/clear.js");
        const addResponse = await axios.post(
          window.Shopify.routes.root + "cart/add.js",
          formData,
        );
        // setTimeout(() => {
        // }, 1000);
        this.enableCheckoutTemp();
        console.log(addResponse.data);
      } catch (err) {
        console.log(err);
      }

      // do the same as above but dont include the subscription ids
    } else {
      console.log("One Time Purchase");
      let formData;

      if (sheduled) {
        formData = {
          attributes: {
            _sheduled: sheduled,
          },
          items: itemsToUpdateNoSub,
        };
      } else {
        formData = {
          items: itemsToUpdateNoSub,
        };
      }

      try {
        await axios.post(window.Shopify.routes.root + "cart/clear.js");
        await axios.post(window.Shopify.routes.root + "cart/add.js", formData);
        this.enableCheckoutTemp();
      } catch (err) {
        console.log(err);
      }
    }

    itemsToUpdate = [];
    itemsToUpdateNoSub = [];
  }

  disableCheckoutTemp() {
    document
      .querySelector(".modal-bottom__main-payment")
      .classList.add("is-loading");
    document
      .querySelector('[js-payment-options="loader"]')
      .classList.remove("visually-hidden");
  }

  enableCheckoutTemp() {
    document
      .querySelector("#meal-plan-addons-cart-cta")
      .classList.remove("disabled");

    document
      .querySelector('[js-payment-options="loader"]')
      .classList.add("visually-hidden");
    document
      .querySelector(".modal-bottom__main-payment")
      .classList.remove("is-loading");
  }
}

customElements.define("payment-options", PaymentOptions);
